import { sbEditable } from '@storyblok/storyblok-editable'
import * as React from 'react'
import styled from 'styled-components'
import CustomLink from '../../components/CustomLink'
import { Button } from '../../components/UI/Button'
import { TitleWithPrefix } from '../../components/UI/TitleWithPrefix'
import { containerDefault } from '../../lib/styles/Container'
import { TextmediaItem } from './TextMediaItem'
import { TextMediaProps } from './types'
import { useI18n } from '../../lib/context/i18n'

export const ModuleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  margin-block: 8rem;
  margin-inline: auto;
`

export const ContentList = styled.div<{ isLarge?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4rem;

  @media screen and (min-width: 1024px) {
    gap: ${p => (p.isLarge ? '1rem' : '4rem')};
  }
`

export const ButtonList = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
`

const Header = styled.div`
  ${containerDefault}
  margin-inline: auto;
  text-align: center;
`

export const TextMedia = ({ blok }: TextMediaProps) => {
  const { getTranslatedUrlFromLink } = useI18n()
  return (
    <ModuleWrapper {...sbEditable(blok)}>
      {blok.headline && (
        <Header>
          <TitleWithPrefix
            title={blok.headline}
            prefix={blok.prefixLine}
            headlineSize={blok.headlineSize}
            headlineType={blok.headlineSyntax}
          />
        </Header>
      )}
      <ContentList isLarge={blok.imageSize === 'large'}>
        {blok.items.map((itemBlok, i) => (
          <TextmediaItem
            key={itemBlok._uid}
            blok={itemBlok}
            index={i + 1}
            isLarge={blok.imageSize === 'large'}
            direction={blok.imagePosition}
          />
        ))}
      </ContentList>
      <ButtonList>
        {blok.buttons.map(buttonBlok => (
          <Button
            as={CustomLink}
            to={getTranslatedUrlFromLink(buttonBlok.link)}
            $variant={buttonBlok.button_style}
            key={buttonBlok._uid}
            {...sbEditable(buttonBlok)}
          >
            {buttonBlok.button_name}
          </Button>
        ))}
      </ButtonList>
    </ModuleWrapper>
  )
}
